module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inMessages) ? _c('f7-list', {
    attrs: {
      "media-list": "",
      "id": "payments-item-received"
    }
  }, _vm._l((_vm.filteredInMessage), function(inMessage) {
    return _c('li', {
      key: inMessage.id,
      staticClass: "swipeout",
      style: ({
        background: _vm.getSeenStatusBackground(inMessage.isRead)
      }),
      on: {
        "swipeout:deleted": function($event) {
          return _vm.onSwipeoutDeleted(inMessage.id)
        }
      }
    }, [_c('div', {
      staticClass: "swipeout-content",
      on: {
        "click": function($event) {
          return _vm.seeDetails(inMessage, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(inMessage.status, inMessage.negotStatus)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "requestTitle"
    }, [_c('div', {
      style: ({
        fontWeight: _vm.getSeenStatusFontWeight(inMessage.isRead)
      })
    }, [_vm._v("\n                    " + _vm._s(inMessage.reason) + "\n                    "), _c('span', {
      staticClass: "showSmallScreenOnly item-subtitle"
    }, [_vm._v("(" + _vm._s(inMessage.amount) + " €)")]), _vm._v(" "), _c('span', {
      staticClass: "showLargeScreenOnly paperclip"
    }, [_vm._v("\n                       "), (inMessage.attachmentId) ? _c('f7-icon', {
      attrs: {
        "fa": "paperclip"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      attrs: {
        "width": "30%"
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.$t('common.total_amount_no_currency')) + ": " + _vm._s(inMessage.amount) + " €")])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('div', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.from') + ': ' + _vm.getSenderName(inMessage)) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(inMessage.creationDate)))]), _vm._v(" "), _c('div', {
      staticClass: "swipeout-actions-right showSmallScreenOnly"
    }, [_c('a', {
      staticClass: "swipeout-delete",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("Delete")])]), _vm._v(" "), (_vm.canDelete()) ? _c('div', {
      staticClass: "item-media showLargeScreenOnly"
    }, [_c('button', {
      staticClass: "button-swipe-out event.stopPropagation()",
      on: {
        "click": function($event) {
          return _vm.deleteOnWeb(inMessage.id, 'IN', $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle button-delete"
    })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-subtitle showSmallScreenOnly"
    }, [_vm._v(_vm._s('From: ' + _vm.getSenderName(inMessage)))]), _vm._v(" "), _c('span', {
      staticClass: "statusLabel showLargeScreenOnly"
    }, [_vm._v(_vm._s(_vm.$t('common.status.status_label')) + ": " + _vm._s(_vm.getStatusLabel(inMessage.status, inMessage.negotStatus, 0)))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', {
      staticClass: "showSmallScreenOnly"
    }, [(inMessage.attachmentId) ? _c('f7-icon', {
      attrs: {
        "fa": "paperclip"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "showLargeScreenOnly"
    }, [(inMessage.reminder === '1') ? _c('f7-icon', {
      staticClass: "orangeFont",
      attrs: {
        "fa": "bell"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row showSmallScreenOnly"
    }, [_c('div', {
      staticClass: "statusLabel"
    }, [_vm._v(_vm._s(_vm.$t('common.status.status_label')) + ": " + _vm._s(_vm.getStatusLabel(inMessage.status, inMessage.negotStatus, 0)))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [(inMessage.reminder === '1') ? _c('f7-icon', {
      staticClass: "orangeFont",
      attrs: {
        "fa": "bell"
      }
    }) : _vm._e()], 1)])])])])])
  }), 0) : _c('f7-list', {
    attrs: {
      "media-list": "",
      "id": "payments-item-sent"
    }
  }, _vm._l((_vm.filteredOutMessage), function(outMessage) {
    return _c('li', {
      key: outMessage.id,
      staticClass: "blackfont swipeout",
      style: ({
        background: _vm.getSeenStatusBackground(outMessage.isRead)
      }),
      on: {
        "swipeout:deleted": function($event) {
          return _vm.onSwipeoutDeleted(outMessage.id)
        }
      }
    }, [_c('div', {
      staticClass: "swipeout-content item-content boxRequest",
      on: {
        "click": function($event) {
          return _vm.seeDetails(outMessage, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(outMessage.status, outMessage.negotStatus)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "requestTitle"
    }, [_c('div', {
      staticClass: "item-title",
      style: ({
        fontWeight: _vm.getSeenStatusFontWeight(outMessage.isRead)
      })
    }, [_vm._v("\n                    " + _vm._s(outMessage.reason) + "\n                    "), _c('span', {
      staticClass: "showLargeScreenOnly paperclip"
    }, [_vm._v("\n                       "), (outMessage.attachmentId) ? _c('f7-icon', {
      attrs: {
        "fa": "paperclip"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                    " + _vm._s('To: ' + _vm.getRecipientName(outMessage)) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(outMessage.creationDate)))]), _vm._v(" "), (_vm.canDelete()) ? _c('div', {
      staticClass: "swipeout-actions-right showSmallScreenOnly"
    }, [_c('a', {
      staticClass: "swipeout-delete",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("Remove")])]) : _vm._e(), _vm._v(" "), (_vm.canDelete()) ? _c('div', {
      staticClass: "item-media showLargeScreenOnly"
    }, [_c('button', {
      staticClass: "button-swipe-out",
      on: {
        "click": function($event) {
          return _vm.deleteOnWeb(outMessage.id, 'OUT', $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle button-delete"
    })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-subtitle showSmallScreenOnly"
    }, [_vm._v(_vm._s('To: ' + _vm.getRecipientName(outMessage)))]), _vm._v(" "), _c('span', {
      staticClass: "statusLabel showLargeScreenOnly"
    }, [_vm._v(_vm._s(_vm.$t('common.status.status_label')) + ": " + _vm._s(_vm.getStatusLabel(outMessage.status, outMessage.negotStatus, 1)))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', {
      staticClass: "showLargeScreenOnly"
    }, [(outMessage.reminder === '1') ? _c('f7-icon', {
      staticClass: "orangeFont",
      attrs: {
        "fa": "bell"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "showSmallScreenOnly"
    }, [(outMessage.attachmentId) ? _c('f7-icon', {
      attrs: {
        "fa": "paperclip"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row showSmallScreenOnly"
    }, [_c('div', {
      staticClass: "statusLabel"
    }, [_vm._v(_vm._s(_vm.$t('common.status.status_label')) + ": " + _vm._s(_vm.getStatusLabel(outMessage.status, outMessage.negotStatus, 1)))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [(outMessage.reminder === '1') ? _c('f7-icon', {
      staticClass: "orangeFont",
      attrs: {
        "fa": "bell"
      }
    }) : _vm._e()], 1)])])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-175d1bca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-175d1bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/TransactionsList.vue
// module id = 1629
// module chunks = 2